import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/themeThree/level_one.png'


const _hoisted_1 = { class: "vip-container" }
const _hoisted_2 = { class: "middle-banner" }
const _hoisted_3 = { class: "topCard" }
const _hoisted_4 = { class: "topText" }
const _hoisted_5 = { class: "middle-header-text" }
const _hoisted_6 = { style: {"color":"#FFA600","font-weight":"700"} }
const _hoisted_7 = { class: "middle-header-text" }
const _hoisted_8 = { style: {"color":"#fff"} }
const _hoisted_9 = { class: "middle-header-text claimable-amount" }
const _hoisted_10 = { style: {"display":"flex","flex-direction":"column","align-items":"flex-end","gap":"5px"} }
const _hoisted_11 = { class: "table-title" }
const _hoisted_12 = { class: "tabs" }
const _hoisted_13 = { class: "bottom_text" }
const _hoisted_14 = ["innerHTML"]

import CustomHeader from '@/themes/themeThree/components/common/customHeader.vue';
import VIPTableView from './vipTableView.vue';
import { computed, ref, watch } from 'vue';
import VipHistoryPopup from './vipHistoryPopup.vue';
import { VipData } from '@/view/vip/supportScript';
import { TAB_LIST_THREE } from '@/view/vip/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'vipViewContent',
  props: {
    dataSet: {},
    isTabView: { type: Boolean }
  },
  emits: ['vIPClaim', 'update:active'],
  setup(__props: any, { emit: __emit }) {

const progressPercentage = computed(() => 6500 * 100 / 10000);
const active = ref(0);
const historyRef = ref()
const vipConfigData = ref()
const tabList = computed(() => {
    var TabList = [...TAB_LIST_THREE]
    if (props.dataSet.vipConfigData?.rewardsStatus.isDailyReward !== 1) {
        TabList = TAB_LIST_THREE.filter(item => item.id !== 2)
    }
    if (props.dataSet.vipConfigData?.rewardsStatus.isWeeklyRewards !== 1) {
        TabList = TabList.filter(item => item.id !== 3)
    }
    if (props.dataSet.vipConfigData?.rewardsStatus.isMonthlyRewards !== 1) {
        TabList = TabList.filter(item => item.id !== 4)
    }
    return TabList
});
const showHistory = () => {
    historyRef.value.open()
}
const props = __props
const emit = __emit

const VIPClaim = () => {
    emit('vIPClaim')
}
watch(active, (val) => {
    emit('update:active', val)
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isTabView)
      ? (_openBlock(), _createBlock(CustomHeader, {
          key: 0,
          text: _ctx.$t('vip.title')
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "subContainer",
        style: _normalizeStyle({padding: _ctx.isTabView ? '0px 25px 25px' : '70px 25px 25px'})
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_row, { class: "toData" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('vip.currentLevel')), 1),
                    _cache[1] || (_cache[1] = _createElementVNode("img", {
                      src: _imports_0,
                      alt: ""
                    }, null, -1))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: 10,
                class: "middle-text-container"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.$t('vip.follow')), 1),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(' VIP ' +
                                    _ctx.dataSet.currentLevel), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t('vip.needToBet')) + " ", 1),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.dataSet.nextLevelRecord?.bet_min), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.$t('vip.receiveBonuses')) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.dataSet.remainRewards), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_van_button, {
                      size: "small",
                      class: "right-btn",
                      style: _normalizeStyle({ background: _ctx.dataSet.remainRewards == 0 ? '#626262' : 'linear-gradient(0deg,rgba(4, 107, 205, 1) 0%, rgba(45, 155, 241, 1) 100%)' }),
                      onClick: VIPClaim
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('vip.collectEverything')), 1)
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_van_button, {
                      size: "small",
                      class: "right-btn",
                      style: {"background":"linear-gradient(0deg,rgba(242, 147, 16, 1) 0%, rgba(252, 182, 89, 1) 100%)"},
                      onClick: showHistory
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('vip.history')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('vip.tireList')), 1),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_van_tabs, {
              id: "vipTabs",
              ellipsis: false,
              active: active.value,
              "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (index) => {
                  return (_openBlock(), _createBlock(_component_van_tab, {
                    title: _ctx.$t(index.name),
                    key: index.id,
                    name: index.id
                  }, null, 8, ["title", "name"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active"])
          ]),
          _createVNode(VIPTableView, {
            activeNo: _ctx.dataSet.active,
            tableData: _ctx.dataSet.tabelData,
            activeData: _ctx.dataSet.vipConfigData?.rewardsStatus,
            vipRewardInfo: _ctx.dataSet.VIPRewardsInfo,
            nextLevelRecord: _ctx.dataSet.nextLevelRecord,
            nextLevel: _ctx.dataSet.nextLevel
          }, null, 8, ["activeNo", "tableData", "activeData", "vipRewardInfo", "nextLevelRecord", "nextLevel"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "24",
                class: "title"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('vip.vipActivityInstructions')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activity_intro, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line_text",
              key: index,
              innerHTML: item
            }, null, 8, _hoisted_14))
          }), 128))
        ])
      ], 4)
    ]),
    _createVNode(VipHistoryPopup, {
      ref_key: "historyRef",
      ref: historyRef
    }, null, 512)
  ], 64))
}
}

})